module.exports = __webpack_public_path__ + "static/img/ivr-hero-sphere.4132734.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ivr-hero-sphere.png
// module id = KHM/
// module chunks = 1